import { motion } from 'framer-motion';
import { TestimonialsColumn } from '../components/ui/testimonials-columns';

const testimonials = [
  {
    text: 'MARK transformó por completo nuestra presencia digital. En solo 3 meses, triplicamos nuestras conversiones y el diseño de nuestra marca ahora refleja exactamente quiénes somos.',
    image: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=100&h=100&fit=crop&crop=face',
    name: 'María Fernanda López',
    role: 'CEO, Lumina Cosmetics',
  },
  {
    text: 'Trabajar con el equipo de MARK fue una experiencia excepcional. Su enfoque estratégico y atención al detalle superaron todas nuestras expectativas.',
    image: 'https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=100&h=100&fit=crop&crop=face',
    name: 'Roberto Castillo',
    role: 'Fundador, TechFlow',
  },
  {
    text: 'La estrategia de redes sociales generó un crecimiento orgánico del 400%. Su equipo entiende el mercado latinoamericano como nadie.',
    image: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?w=100&h=100&fit=crop&crop=face',
    name: 'Ana Sofía Guerrero',
    role: 'Directora de Marketing, Café Origen',
  },
  {
    text: 'El rediseño de nuestra web incrementó las conversiones un 180%. Un equipo que realmente entiende de resultados y negocio digital.',
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop&crop=face',
    name: 'Carlos Mendoza',
    role: 'CTO, DataPulse',
  },
  {
    text: 'Desde el primer día sentimos que MARK era un socio estratégico, no solo un proveedor. La diferencia se nota en cada entregable.',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=100&h=100&fit=crop&crop=face',
    name: 'Lucía Herrera',
    role: 'COO, VerdeMX',
  },
  {
    text: 'Su capacidad para combinar creatividad con datos duros es lo que los diferencia. Cada campaña viene respaldada con métricas claras.',
    image: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?w=100&h=100&fit=crop&crop=face',
    name: 'Andrés Villalobos',
    role: 'VP Marketing, UrbanFit',
  },
  {
    text: 'MARK nos ayudó a definir nuestra identidad de marca desde cero. El resultado superó lo que imaginábamos.',
    image: 'https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=100&h=100&fit=crop&crop=face',
    name: 'Valentina Rojas',
    role: 'Fundadora, Alma Studio',
  },
  {
    text: 'La gestión de nuestras redes sociales pasó de ser un dolor de cabeza a ser nuestro canal principal de adquisición.',
    image: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop&crop=face',
    name: 'Felipe Torres',
    role: 'Director General, NovaTech',
  },
  {
    text: 'Profesionalismo, creatividad y resultados. Tres palabras que definen nuestra experiencia trabajando con MARK.',
    image: 'https://images.unsplash.com/photo-1531746020798-e6953c6e8e04?w=100&h=100&fit=crop&crop=face',
    name: 'Isabella Navarro',
    role: 'Gerente de Marca, Lux Hotels',
  },
];

const firstCol = testimonials.slice(0, 3);
const secondCol = testimonials.slice(3, 6);
const thirdCol = testimonials.slice(6, 9);

export default function Testimonials() {
  return (
    <div className="page">
      <section className="bg-white py-24 relative">
        <div className="max-w-6xl mx-auto px-6">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1, ease: [0.16, 1, 0.3, 1] }}
            viewport={{ once: true }}
            className="flex flex-col items-center justify-center max-w-[540px] mx-auto"
          >
            <div className="flex justify-center">
              <div className="border border-neutral-200 py-1 px-4 rounded-lg text-sm text-neutral-500">
                Testimonios
              </div>
            </div>
            <h2
              className="text-3xl md:text-5xl font-bold tracking-tighter mt-5 text-center text-neutral-900"
              style={{ fontFamily: "'Playfair Display', Georgia, serif" }}
            >
              Lo que dicen nuestros clientes
            </h2>
            <p className="text-center mt-5 text-neutral-500">
              La satisfacción de nuestros clientes es nuestra mejor carta de presentación.
            </p>
          </motion.div>

          <div className="flex justify-center gap-6 mt-10 [mask-image:linear-gradient(to_bottom,transparent,black_25%,black_75%,transparent)] max-h-[740px] overflow-hidden">
            <TestimonialsColumn testimonials={firstCol} duration={15} />
            <TestimonialsColumn testimonials={secondCol} className="hidden md:block" duration={19} />
            <TestimonialsColumn testimonials={thirdCol} className="hidden lg:block" duration={17} />
          </div>
        </div>
      </section>
    </div>
  );
}
